export const getAssignee = message => message?.conversation?.assignee_id;
export const isConversationUnassigned = message => !getAssignee(message);
export const isConversationAssignedToMe = (message, currentUserId) =>
  getAssignee(message) === currentUserId;
export const isMessageFromCurrentUser = (message, currentUserId) =>
  message?.sender?.id === currentUserId;
export const isInternalMessage = (message, getConversationById) => {
  if (message?.conversation?.internal_conversation === true) {
    return true;
  }

  if (!getConversationById || !message?.conversation_id) {
    return false;
  }

  const chat = getConversationById(message.conversation_id);
  return !!(
    chat?.meta?.internal_conversation ||
    chat?.additional_attributes?.internal_conversation
  );
};
